import React from 'react';
import { useState, useEffect } from 'react';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import { Box, Button } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { Switch, FormControlLabel } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';

import { hasUserRole } from '../../../utils/AuthUtils';
import ServiceAPI from '../../../service/ServiceAPI';
import Constants from '../../../utils/Constants';


const InventroyList = function(props) {

  const navigate = useNavigate();

  let [inventories, setInventories] = useState(null);
  let [showArchived, setShowArchived] = useState(false);

  useEffect(() => {
    ServiceAPI.Inventory().getListing().then((data) => {
      setInventories(data);
    });
  }, []);

  const onClick_CompleteInventory = (id) => {
    if (!Constants.FeatureToggle.CompleteInventoryEnabled) {
      return; // Do nothing if the feature toggle is off.
    }
    
    navigate(Constants.RoutePath.Inventory.Complete(id));
  }

  const onClick_EditInventory = (id) => {
    navigate(Constants.RoutePath.Inventory.Edit(id));
  }

  const onClick_ShowArchivedInventories = () => {
    let state = !showArchived;
    setShowArchived(state);
  }

  const onClick_ArchiveInventory = (inventory) => {
    console.debug(inventory);

    inventory.archived = 1;

    // Send the Update to the API and then update the local data model to update the users screen.
    ServiceAPI.Inventory().updateInventory(inventory).then(() => { 
      let tmpInventories = [ ...inventories ];
      let indexOfSelectedInventory = tmpInventories.findIndex((needle) => { return needle.id === inventory.id});

      // Should check that the index is not -1, but I cant think of anyway they could get here AND have -1 return from the above.
      tmpInventories[indexOfSelectedInventory].archived = 1;
      
      setInventories(tmpInventories); 
    });
  }

  const onClick_PdfInventory = (id) => {
    navigate(Constants.RoutePath.Inventory.Pdf(id));
  }

  const onClick_CreateNewInventory = () => {
    navigate(Constants.RoutePath.Inventory.Create);
  }

  const render = function() {
    if (inventories === null) {
      return <h1>Loading Inventory List</h1>
    }

    return (
      <Box style={{margin: 'auto'}} display={'flex'} flexDirection={'column'} height={'90%'}>
        <Box>
          { renderManagerOptions() }
        </Box>
        <Box flex={1} overflow={'auto'}>
          { inventories.map((item) => { return InventoryCard(item); }) }
        </Box>
      </Box>
    );
  }

  const renderManagerOptions = () => {
    if ( !hasUserRole(Constants.UserRole.InventoryManager) ) {
      return null;
    }

    return (
      <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingBottom: '2em'}}>
        { NewInventoryCard() }
        { renderShowArchiveSwitch() }
      </div>
    );

  }

  const renderShowArchiveSwitch = () => {
    if ( !hasUserRole(Constants.UserRole.InventoryManager) ) {
      return null;
    }

    return (
      <div>
        <FormControlLabel
          label="Show Archived Inventories"
           labelPlacement="start"
          control={
            <Switch
              checked={showArchived}
              onChange={onClick_ShowArchivedInventories}
              color="primary"
            />
          }
        />
          
      </div>
    );
  }

  const InventoryCard = function(inventory) {
    if (inventory.archived === 1  && showArchived === false) {
      return null; // Dont display archived inventories in the main list unless the toggle is on
    }

    let archiveButton = (
      <Button size="small" color="primary" onClick={() => { onClick_ArchiveInventory(inventory) }}>
        Archive
      </Button>
    );

    let managerFunctions = (
      <>
        <Button size="small" color="primary" onClick={() => { onClick_EditInventory(inventory.id) }}>
          Edit
        </Button>
        { inventory.archived === 0 ? archiveButton : null }
      </>
    );
  
    let archiveStyle = inventory.archived === 0 ? null : { backgroundColor: 'aliceblue'};

    return <Card key={inventory.id} style={{width: '', display: 'block', margin: '1em', ...archiveStyle}}>
      <CardActionArea onClick={(e) => { onClick_CompleteInventory(inventory.id) } }>
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            {inventory.name} 
          </Typography>
          <Typography gutterBottom variant="h5" component="h2">
            v{inventory.version}
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions>
        
        <Button size="small" color="primary" onClick={() => { onClick_PdfInventory(inventory.id) }}>
          Print
        </Button>
        { hasUserRole(Constants.UserRole.InventoryManager) ? managerFunctions : null }
      </CardActions>
    </Card>
  }

  const NewInventoryCard = function() {
    if ( hasUserRole(Constants.UserRole.InventoryManager) !== true ) {
      return null;
    }

    return (
      <Button 
        size="large" 
        variant="contained" 
        color="primary" 
        onClick={onClick_CreateNewInventory}
      >
        New Inventory
      </Button>
    );
   }

  return render()
}

export default InventroyList;
